import React from 'react';
import Modal from '../../../../components/Modal/Modal';
import NiceModal from '@ebay/nice-modal-react';
import { ModalBody, Spinner } from 'reactstrap';
import { Flex } from '@chakra-ui/react';

const LoadingModal = ({ title, onCloseIcon }) => {
	return (
		<Modal
			onCloseIcon={onCloseIcon}
			title={title || 'Confrontando huella'}
			size="md"
		>
			<ModalBody>
				<Flex
					direction="column"
					minHeight="200px"
					justifyContent="center"
					alignItems="center"
				>
					<Spinner color="primary" className="me-25" size="xxl" />
				</Flex>
			</ModalBody>
		</Modal>
	);
};

export default NiceModal.create(LoadingModal);
